<template>
    <st-modal
        ref="st-add-tax-modal"
        hideable
        hide-footer
        hide-header-delimiter
        hide-footer-delimiter
        no-close-on-backdrop
        no-close-on-esc
        size="md"
        :hideHeaderClose="loading"
        :title="$t('TAXES.MODALS.ADD_TITLE')"
    >
        <template #body>
            <tax-form
                @cancelForm="hide"
                @submitForm="submit"
            >
                <template #buttons="{ submit, cancel }">
                    <div class="d-flex justify-content-between">
                        <st-button
                            size="large"
                            variant="link"
                            :callback="cancel"
                            :disabled="loading"
                        >
                            {{ $t('TAXES.MODALS.CANCEL') }}
                        </st-button>
                        <st-button
                            size="large"
                            :callback="submit"
                            :spinner="loading"
                        >
                            {{ $t('TAXES.MODALS.ADD') }}
                        </st-button>
                    </div>
                </template>
            </tax-form>
        </template>
    </st-modal>
</template>

<script>
import TaxForm from './TaxForm.vue';

export default {
    name: 'AddTaxModal',
    components: {
        TaxForm
    },
    props: {
        loading: {
            type: Boolean,
        },
    },
    methods: {
        show() {
            this.$refs['st-add-tax-modal'].show();
        },
        hide() {
            this.$refs['st-add-tax-modal'].hide();
        },
        submit(tax) {
            this.$emit('submit', tax);
        },
    },
}
</script>